export const serverUrl:string = "https://api.whiteb.dev"
